import { Fragment, useMemo } from 'react';
import type { FilterConfig } from '@alltrails/denali/components/FilterBar';
import FilterControl from '../FilterControl/FilterControl';
import styles from './FiltersModalContent.module.scss';

type FiltersModalProps = {
  filterConfigs: FilterConfig[];
};

const FiltersModalContent = ({ filterConfigs }: FiltersModalProps) => {
  const renderedFilters = useMemo(() => {
    return filterConfigs.map((filterConfig, index) => {
      const filterControl = <FilterControl filterConfig={filterConfig} />;

      return filterControl ? (
        <Fragment key={`filter-${index}`}>
          {filterControl}
          <div className={styles.divider} />
        </Fragment>
      ) : null;
    });
  }, [filterConfigs]);

  return <div className={styles.container}>{renderedFilters}</div>;
};

export default FiltersModalContent;
